import { render, staticRenderFns } from "./yingyangku.vue?vue&type=template&id=385217b7&scoped=true"
import script from "./yingyangku.vue?vue&type=script&scoped=true&lang=ts"
export * from "./yingyangku.vue?vue&type=script&scoped=true&lang=ts"
import style0 from "./yingyangku.vue?vue&type=style&index=0&id=385217b7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385217b7",
  null
  
)

export default component.exports